module.exports = "/_next/static/images/63d53170a93429947220b6f9d2add837-ppf.png";